// extracted by css-extract-rspack-plugin
export default {"root":"root-tMfemk","emptyState":"emptyState-Ss2vud"};